import msg from "components/string-table";
import { Colors, Icon } from "main";
import { generateSwingSupportURL } from "swing-utils";

import styles from "./SwingHeroNotYetEligible.module.css";

type SwingHeroNotYetEligibleProps = {
  subDaysWorked: number;
  isHourly: boolean;
  onClick?: () => void;
};

export function SwingHeroNotYetEligible(props: SwingHeroNotYetEligibleProps) {
  const { subDaysWorked, onClick, isHourly } = props;
  const progressBarTitle = getProgressBarTitle(subDaysWorked);

  return (
    <div className={styles.container}>
      <p className={styles.title}>{msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_TITLE")}</p>
      <p className={styles.subTitle}>{msg("SWING_HERO_NOT_YET_ELIGIBLE_SUB_TEXT")}</p>
      <div className={styles.progressTrackerContainer}>
        <p className={styles.progressTrackerTitle}>{progressBarTitle}</p>
        <div style={{ position: "relative" }}>
          <div className={styles.progressBar}></div>
          <div className={styles.progressTracker}>{renderProgressCircles(subDaysWorked)}</div>
        </div>
        {subDaysWorked >= 5 && (
          <p className={styles.progressTrackerSubText}>
            {msg("SWING_HERO_NOT_YET_ELIGIBLE_PROGRESS_BAR_SUB_TEXT")}
          </p>
        )}
      </div>
      {/* TODO: To update with design system button when ready */}
      <div className={styles.buttonContainer}>
        <button className={styles.button} onClick={onClick}>
          {msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_BUTTON_LABEL")}
        </button>
      </div>
      <List title={msg("SWING_HERO_NOT_YET_ELIGIBLE_EARN_HIGH_SCORE_LIST_TITLE")} type="score" />
      <List title={msg("SWING_HERO_NOT_YET_ELIGIBLE_PERKS_LIST_TITLE")} type="perks" />
      <p style={{ margin: "12px 0", textAlign: "center" }}>
        {`${msg("SWING_HERO_LEARN_MORE_ABOUT")} `}
        <a
          href={generateSwingSupportURL(
            isHourly
              ? msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_SUPPORT_ARTICLE_LINK_W2")
              : msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_SUPPORT_ARTICLE_LINK_1099"),
          )}
          target="_blank"
          rel="noreferrer"
        >
          {msg("SWING_HEROES")}
        </a>
        .
      </p>
    </div>
  );
}

export function getProgressBarTitle(subDaysWorked: number) {
  if (subDaysWorked < 1) return msg("SWING_HERO_NOT_YET_ELIGIBLE_PROGRESS_BAR_INITIAL_TITLE");
  if (subDaysWorked < 5)
    return msg("SWING_HERO_NOT_YET_ELIGIBLE_PROGRESS_BAR_TITLE", 5 - subDaysWorked);
  return msg("SWING_HERO_NOT_YET_ELIGIBLE_PROGRESS_BAR_COMPLETED");
}

export function renderProgressCircles(subDaysWorked: number) {
  return Array.from({ length: 5 }, (_, index) => (
    <div
      key={index}
      data-testid="progress-circle"
      className={`${styles.circle} ${index < subDaysWorked ? styles.filled : ""}`}
    />
  ));
}

const listMessages = {
  score: {
    FIRST: msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_EARN_HIGH_SCORE_LIST_FIRST_ITEM"),
    SECOND: msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_EARN_HIGH_SCORE_LIST_SECOND_ITEM"),
    THIRD: msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_EARN_HIGH_SCORE_LIST_THIRD_ITEM"),
  },
  perks: {
    FIRST: msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_PERKS_LIST_FIRST_ITEM"),
    SECOND: msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_PERKS_LIST_SECOND_ITEM"),
    THIRD: msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_PERKS_LIST_THIRD_ITEM"),
  },
};

const listIconConfig = {
  score: { iconName: "Check Circle" as const, color: Colors.green500 },
  perks: { iconName: "Star Circle" as const, color: undefined },
};

type ListProps = {
  title: string;
  type: keyof typeof listMessages;
};

function List(props: ListProps) {
  const { title, type } = props;
  const { iconName, color } = listIconConfig[type];

  const renderListItem = (text: string, idx: number) => (
    <li key={`${type}-${idx}`} className={styles.listItem}>
      <div className={styles.listItemIcon}>
        <Icon name={iconName} {...(color && { color })} />
      </div>
      {text}
    </li>
  );

  return (
    <div style={{ alignSelf: "flex-start" }}>
      <p className={styles.listTitle}>{title}</p>
      <ul className={styles.list}>
        {Object.values(listMessages[type]).map((text, idx) => renderListItem(text, idx))}
      </ul>
    </div>
  );
}
